import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-600bbd2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "mt-5" }, "Prihlásenie sa", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_text_input = _resolveComponent("text-input")!
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!
  const _component_form_tag = _resolveComponent("form-tag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createVNode(_component_form_tag, {
          onMyevent: $options.submitHandler,
          name: "myform",
          event: "myevent"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_text_input, {
              modelValue: $data.email,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.email) = $event)),
              label: "Email",
              type: "email",
              name: "email",
              id: "loginEmail",
              required: "true"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_text_input, {
              modelValue: $data.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.password) = $event)),
              label: "Password",
              type: "password",
              name: "password",
              id: "loginPassword",
              required: "true"
            }, null, 8, ["modelValue"]),
            _hoisted_6,
            _createVNode(_component_PrimevueButton, {
              type: "submit",
              label: "Prihlásiť sa",
              text: "",
              raised: "",
              class: ""
            })
          ]),
          _: 1
        }, 8, ["onMyevent"])
      ])
    ])
  ]))
}